import { lazy } from 'react';
import { type RouteObject } from 'react-router';

import { dashboardRoutes } from './Dashboard';

const ErrorPage = lazy(() => import('src/pages/ErrorPage'));

export const routesSection: RouteObject[] = [
  ...dashboardRoutes,
  { path: '*', element: <ErrorPage status={404} /> },
];
